import node from './nodejs.png'

const BACKEND = { node }

export const BACKEND_ARRAY=[ node ]

export default BACKEND